import { postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";

const conversation = apiUrl + "/conversation";
const routes = {
  label: "Conversation",
  root: conversation,
  new: conversation + "/new",
  get_between_me_and_another_company: conversation + "/get_between_me_and_another_company",
  get_unread_count_between_me_and_another_company: conversation + "/get_unread_count_between_me_and_another_company",
  read: conversation + "/read",
};
export const Conversation = {
  new: (receiver_id, content) => postWithToken(routes.new, { receiver_id, content }),
  get_between_me_and_another_company: (company_id) => postWithToken(routes.get_between_me_and_another_company, { company_id }),
  get_unread_count_between_me_and_another_company: (company_id) => postWithToken(routes.get_unread_count_between_me_and_another_company, { company_id }),
  read: (ids) => postWithToken(routes.read, { ids }),
};
